import type { PermissionEnum } from '@Application/Security/Roles';

class UpdateRole {
	constructor(
		public readonly accountId: number,
		public readonly roleId: number,
		public readonly label: string,
		public readonly description: string | null,
		public readonly permissions: readonly PermissionEnum[],
	) {
		Object.freeze(this);
	}

	// `accountId` and `roleId` are route identifiers: neither is echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			label: this.label,
			description: this.description,
			permissions: this.permissions,
		};
	}
}

export default UpdateRole;
